import React, { Component, Fragment } from 'react'
import { Link } from 'react-router-dom';
import Moment from 'moment';
import Breadcrumb from '../common/breadcrumb';
import VerDetailsOrderDatatable from '../common/ver-details-order-datatable';
import AuthService from "../services/auth.service";
import ApiService from "../services/api.service";
import 'react-toastify/dist/ReactToastify.css';
import Swal from 'sweetalert2';
import Modal from 'react-responsive-modal';
import { CSVLink } from 'react-csv';
import { SortableTh, sortRows, nextSort } from '../common/sortable-th';
import { StatCardsGrid } from '../common/stat-cards';
import { DateRangeInput } from '../common/date-range-input';

function today() {
    return Moment().format('YYYY-MM-DD');
}

// mismo patrón de exportación que ver-report-products-sold (react-csv)
const ORDER_HEADERS = [
    { label: 'Id', key: 'Id' },
    { label: 'Usuario', key: 'Usuario' },
    { label: 'Embajador', key: 'Embajador' },
    { label: 'Fecha', key: 'Fecha' },
    { label: 'Hora', key: 'Hora' },
    { label: 'Estado', key: 'Estado' },
    { label: 'Delivery', key: 'Delivery' },
    { label: 'Total', key: 'Total' },
];

function csvFilename(periodLabel) {
    const safePeriod = periodLabel ? periodLabel.replace(/\s+/g, '') : 'sin-filtro';
    return `pedidos_${safePeriod}.csv`;
}

function fmtMoney(val) {
    if (val === null || val === undefined || val === '') return '—';
    const num = parseFloat(val);
    if (isNaN(num)) return '—';
    return 'S/ ' + num.toLocaleString('es-PE', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
}

function fmtPercent(val) {
    if (val === null || val === undefined || val === '') return '—';
    const num = parseFloat(val);
    if (isNaN(num)) return '—';
    return Math.round(num * 100) + '%';
}

// colores de badge por estado del pedido, mismo criterio visual que el
// resto de reportes modernizados (ver-report-products-sold)
const ESTADO_COLORS = {
    APROBADO: { bg: '#d4edda', color: '#155724' },
    PROCESADO: { bg: '#fff3cd', color: '#856404' },
    CANCELADO: { bg: '#f8d7da', color: '#721c24' },
    PENDIENTE: { bg: '#e2e3e5', color: '#383d41' },
};

function estadoBadge(estado) {
    const s = ESTADO_COLORS[estado] || { bg: '#e2e3e5', color: '#383d41' };
    return (
        <span style={{ background: s.bg, color: s.color, borderRadius: 10, padding: '2px 9px', fontSize: 12, fontWeight: 600, whiteSpace: 'nowrap' }}>
            {estado}
        </span>
    );
}

const ICON_BTN_STYLE = { border: 'none', background: 'transparent', cursor: 'pointer', padding: '5px 7px', fontSize: 16 };

export class VerReportOrderList extends Component {
    constructor(props) {
        super(props);
        this.onChangeFilter = this.onChangeFilter.bind(this);
        this.handlerAcept = this.handlerAcept.bind(this);
        this.handlerCancel = this.handlerCancel.bind(this);
        this.handlerRemove = this.handlerRemove.bind(this);
        this.handlerDetails = this.handlerDetails.bind(this);
        this.handleSort = this.handleSort.bind(this);
        this.state = {
            open: false,
            results: [],
            filter: '',
            temp: [],
            detailResults: [],
            client: '',
            date: '',
            hour: '',
            id_order: null,
            total_order: null,
            address: '',
            district: '',
            interior: '',
            url_google: '',
            cash: 0,
            delivery: 0,
            discount: 0,
            dataSubCateg: 0,
            dataUtility: 0,
            dataCosts: 0,
            dataDelivery: 0,
            profitUtility: 0,
            averageTicket: 0,
            numTotalOrders: 0,
            totalCustomers: 0,
            percentageActiveCustomers: 0,
            totalOrdersAverage: 0,
            cashGranted: 0,
            cashUsed: 0,
            page: 1,
            sort: { key: 'Id', dir: 'desc' },
            // filtro por rango de fechas, igual que ver-report-products-sold
            loading: false,
            dateFrom: today(),
            dateTo: today(),
        };
        this.applyDateRange = this.applyDateRange.bind(this);
    }

    handleSort(key) {
        this.setState((prev) => ({
            sort: nextSort(prev.sort, key),
            page: 1,
        }));
    }

    applyDateRange(from, to) {
        this.setState({ dateFrom: from, dateTo: to }, () => this.getData());
    }

    // transforma las purchases crudas del backend a las filas que usa la tabla
    mapPurchasesToRows(rawPurchases) {
        return rawPurchases.map(function (row) {
            var start_time = row.hour_programmed_start ? row.hour_programmed_start.toString() : '';
            var end_time = row.hour_programmed_end ? row.hour_programmed_end.toString() : '';
            var nameAmbassador = row.Referred && row.Referred.name ? row.Referred.name : '-';
            var lastnameAmbassador = row.Referred && row.Referred.last_name ? row.Referred.last_name : '-';
            var totalOrder = row.totalOrder;
            return {
                Id: row.id,
                id_user: row.id_user,
                Usuario: row.User.name + ' ' + row.User.last_name,
                Embajador: nameAmbassador + ' ' + lastnameAmbassador,
                Fecha: row.date_programmed,
                Hora: start_time && end_time ? start_time.slice(0, -3) + ' - ' + end_time.slice(0, -3) : '',
                Estado: row.status,
                address: row.address,
                Delivery: row.delivery ? row.delivery : "0.00",
                Total: totalOrder,
                data: row,
            };
        });
    }

    getData() {
        var user = AuthService.getCurrentUser();
        this.setState({ loading: true });
        const { dateFrom, dateTo } = this.state;

        ApiService.getOrdersReportRange(user.token, dateFrom, dateTo).then(
            (res) => {
                if (res && res.status === 'success') {
                    const data = res.data;
                    const items = this.mapPurchasesToRows(data.data);
                    this.setState({
                        loading: false,
                        dataUtility: data.totalUtility,
                        dataCosts: data.totalCosts,
                        dataSubCateg: data.totalOrders,
                        dataDelivery: data.totalDelivery,
                        profitUtility: data.profitUtility,
                        averageTicket: data.averageTicket,
                        numTotalOrders: data.numTotalOrders,
                        totalCustomers: data.totalCustomers,
                        percentageActiveCustomers: data.percentageActiveCustomers,
                        totalOrdersAverage: data.totalOrdersAverage,
                        cashGranted: data.cashGranted,
                        cashUsed: data.cashUsed,
                        results: items,
                        temp: items,
                        page: 1,
                    });
                } else {
                    this.setState({ loading: false, results: [], temp: [] });
                }
            },
            () => {
                this.setState({ loading: false, results: [], temp: [] });
            }
        );
    }

    onChangeFilter(e) {

        this.setState({
            filter: e.target.value
        }, function () {
        });

        const val = e.target.value.toLowerCase();
        if (this.state.temp.length != 0) {
          var columns = Object.keys(this.state.temp[0]);
          //Los botones de acciones se pintan despues
          columns.splice(columns.length);
          //columns.splice(columns.length - 1);
    
          if (!columns.length)
            return;
          const rows = this.state.temp.filter(function (d) {
            for (let i = 0; i <= columns.length; i++) {
              let column = columns[i];
              if (d[column] && d[column].toString().toLowerCase().indexOf(val) > -1) {
                return true;
              }
            }
          });
          this.setState({
            results: rows
        }, function () {
            this.renderResults(this.state.results.length);
        });
          
        }



        e.preventDefault();
      }

    componentWillMount() {
        this.getData();
    }

    // arranca con el menú lateral cerrado para dejar más espacio a la tabla
    // (mismo patrón que ver-customer-profile), y lo restaura al salir de la vista
    componentDidMount() {
        document.querySelector(".page-main-header") &&
            document.querySelector(".page-main-header").classList.add("open");
        document.querySelector(".page-sidebar") &&
            document.querySelector(".page-sidebar").classList.add("open");
    }

    componentWillUnmount() {
        document.querySelector(".page-main-header") &&
            document.querySelector(".page-main-header").classList.remove("open");
        document.querySelector(".page-sidebar") &&
            document.querySelector(".page-sidebar").classList.remove("open");
    }

    getDataOrders(){
        var user = AuthService.getCurrentUser();
        ApiService.getOrders(user.token).then(
            (res) => {
                if(res && res.status == 'success'){
                    const items = res.data.map(function(row) {
                        var start_time = row.hour_programmed_start?row.hour_programmed_start.toString():'';
                        var end_time = row.hour_programmed_end?row.hour_programmed_end.toString():'';
                        var nameAmbassador = row.Referred && row.Referred.name ? row.Referred.name : '-';
                        var lastnameAmbassador = row.Referred && row.Referred.last_name ? row.Referred.last_name : '-';
                        var totalOrder = row.totalOrder;
                        return { 
                            Id: row.id, 
                            id_user: row.id_user,
                            Usuario : row.User.name + ' ' + row.User.last_name, 
                            Embajador : nameAmbassador + ' ' + lastnameAmbassador, 
                            Fecha: row.date_programmed,
                            Hora: start_time && end_time?start_time.slice(0, -3) + ' - '+ end_time.slice(0, -3):'',
                            Estado : row.status, 
                            address: row.address,
                            Delivery: row.delivery?row.delivery:"0.00",
                            Total : totalOrder,
                            data: row,
                        }
                     })
                this.setState({ results:items });
                this.setState({ temp:items });
                this.renderResults(this.state.results.length);
                }
            },
            error => {
              const resMessage =
                (error.response &&
                  error.response.data &&
                  error.response.data.message) ||
                error.message ||
                error.toString();
            }
          );
    }

    renderPagination(total, page, pageSize, onPageChange) {
        const totalPages = Math.ceil(total / pageSize);
        if (totalPages <= 1) return null;
        const from = (page - 1) * pageSize + 1;
        const to = Math.min(page * pageSize, total);
        return (
            <div style={{
                display: 'flex', flexWrap: 'wrap', alignItems: 'center', justifyContent: 'space-between',
                padding: '10px 16px', borderTop: '1px solid #f0f0f0', gap: 8,
                background: '#fafafa', fontSize: 13, color: '#666',
            }}>
                <span style={{ fontSize: 12, color: '#aaa' }}>{from}–{to} de {total}</span>
                <div style={{ display: 'flex', gap: 6 }}>
                    <button
                        disabled={page === 1}
                        onClick={() => onPageChange(page - 1)}
                        style={{
                            border: '1px solid #ddd', borderRadius: 6, padding: '4px 12px',
                            background: page === 1 ? '#f4f4f4' : '#fff',
                            color: page === 1 ? '#ccc' : '#333',
                            cursor: page === 1 ? 'default' : 'pointer', fontSize: 13,
                        }}
                    >
                        <i className='fa fa-chevron-left' />
                    </button>
                    <span style={{ padding: '4px 10px', fontSize: 13, color: '#555' }}>{page} / {totalPages}</span>
                    <button
                        disabled={page === totalPages}
                        onClick={() => onPageChange(page + 1)}
                        style={{
                            border: '1px solid #ddd', borderRadius: 6, padding: '4px 12px',
                            background: page === totalPages ? '#f4f4f4' : '#fff',
                            color: page === totalPages ? '#ccc' : '#333',
                            cursor: page === totalPages ? 'default' : 'pointer', fontSize: 13,
                        }}
                    >
                        <i className='fa fa-chevron-right' />
                    </button>
                </div>
            </div>
        );
    }

    renderResults(){
        const { results, page, sort, loading } = this.state;
        if (loading) return <div style={{ padding: 16, color: '#888' }}>Cargando...</div>;
        if (results.length === 0) return <div style={{ padding: 16, color: '#888' }}>No hay datos.</div>;

        const PAGE_SIZE = 50;
        const sorted = sortRows(results, sort);
        const totalPages = Math.max(1, Math.ceil(sorted.length / PAGE_SIZE));
        const currentPage = Math.min(page, totalPages);
        const paginated = sorted.slice((currentPage - 1) * PAGE_SIZE, currentPage * PAGE_SIZE);

        const headers = [
            { label: 'Id', key: 'Id', align: 'left' },
            { label: 'Usuario', key: 'Usuario', align: 'left' },
            { label: 'Embajador', key: 'Embajador', align: 'left' },
            { label: 'Fecha', key: 'Fecha', align: 'center' },
            { label: 'Hora', key: 'Hora', align: 'center' },
            { label: 'Estado', key: 'Estado', align: 'center' },
            { label: 'Delivery', key: 'Delivery', align: 'right' },
            { label: 'Total', key: 'Total', align: 'right' },
        ];

        return (
            <div style={{ border: '1px solid #ebebeb', borderRadius: 10, overflow: 'hidden' }}>
                <div style={{ overflowX: 'auto' }}>
                    <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: 13 }}>
                        <thead>
                            <tr style={{ background: '#f8f9fa', borderBottom: '2px solid #ebebeb' }}>
                                {headers.map((h) => (
                                    <SortableTh key={h.key} header={h} sort={sort} onSort={this.handleSort} style={{ textAlign: h.align }} />
                                ))}
                                <th style={{ padding: '10px 12px', color: '#888', fontWeight: 600, textAlign: 'center', whiteSpace: 'nowrap' }}>
                                    Acción
                                </th>
                            </tr>
                        </thead>
                        <tbody>
                            {paginated.map((item) => (
                                <tr
                                    key={item.Id}
                                    style={{ borderBottom: '1px solid #f4f4f4' }}
                                    onMouseEnter={(e) => (e.currentTarget.style.background = '#f8fbff')}
                                    onMouseLeave={(e) => (e.currentTarget.style.background = '')}
                                >
                                    <td style={{ padding: '9px 12px', whiteSpace: 'nowrap', fontWeight: 500, textAlign: 'left' }}>{item.Id}</td>
                                    <td style={{ padding: '9px 12px', whiteSpace: 'nowrap', textAlign: 'left' }}>
                                        <Link
                                            to={`${process.env.PUBLIC_URL}/customer-profile/${item.id_user}`}
                                            target="_blank"
                                            rel="noopener noreferrer"
                                            style={{ color: '#007bff', fontWeight: 500 }}
                                        >
                                            {item.Usuario}
                                        </Link>
                                    </td>
                                    <td style={{ padding: '9px 12px', whiteSpace: 'nowrap', color: '#666', textAlign: 'left' }}>{item.Embajador}</td>
                                    <td style={{ padding: '9px 12px', whiteSpace: 'nowrap', color: '#666', textAlign: 'center' }}>{item.Fecha}</td>
                                    <td style={{ padding: '9px 12px', whiteSpace: 'nowrap', color: '#666', textAlign: 'center' }}>{item.Hora}</td>
                                    <td style={{ padding: '9px 12px', whiteSpace: 'nowrap', textAlign: 'center' }}>{estadoBadge(item.Estado)}</td>
                                    <td style={{ padding: '9px 12px', whiteSpace: 'nowrap', color: '#666', textAlign: 'right' }}>{fmtMoney(item.Delivery)}</td>
                                    <td style={{ padding: '9px 12px', whiteSpace: 'nowrap', fontWeight: 700, textAlign: 'right' }}>{fmtMoney(item.Total)}</td>
                                    <td style={{ padding: '9px 12px', whiteSpace: 'nowrap', textAlign: 'center' }}>
                                        <div style={{ display: 'flex', justifyContent: 'center' }}>
                                            <button type="button" title="Ver detalle" style={ICON_BTN_STYLE} onClick={() => this.handlerDetails({ original: item })}>
                                                <i className="fa fa-eye" style={{ color: 'rgb(48 159 212)' }} />
                                            </button>
                                            {item.Estado === 'PROCESADO' && (
                                                <Fragment>
                                                    <button type="button" title="Aceptar" style={ICON_BTN_STYLE} onClick={() => this.handlerAcept({ original: item })}>
                                                        <i className="fa fa-check-circle" style={{ color: 'rgb(40, 167, 69)' }} />
                                                    </button>
                                                    <button type="button" title="Rechazar" style={ICON_BTN_STYLE} onClick={() => this.handlerCancel({ original: item })}>
                                                        <i className="fa fa-times-circle" style={{ color: 'rgb(251, 15, 15)' }} />
                                                    </button>
                                                </Fragment>
                                            )}
                                            <button type="button" title="Eliminar" style={ICON_BTN_STYLE} onClick={() => this.handlerRemove({ original: item })}>
                                                <i className="fa fa-trash" style={{ color: '#e4566e' }} />
                                            </button>
                                        </div>
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
                {this.renderPagination(sorted.length, currentPage, PAGE_SIZE, (p) => this.setState({ page: p }))}
            </div>
        );
    }

    renderDetailResults(){
		return this.state.detailResults.length === 0 
			? ''
			: <VerDetailsOrderDatatable
            multiSelectOption={false}
            myData={this.state.detailResults}
            pageSize={this.state.detailResults.length+1}
            pagination={true}
            class="-striped -highlight"
        />
    }   

    showImage(results){
        // Aplicamos un fix si no devuelve una imagen 
        let url_image = `${process.env.REACT_APP_URL_FILES}/images/products/`;
            for (let i = 0; i < results.length; i++){
                results[i]['imagen'] = <img src={url_image + (results[i]['Product']['url']?results[i]['Product']['url']:(results[i]['Product']['logo']?results[i]['Product']['logo']:''))} style={{width:50,height:50}}/>;
            }
            return results;
        }

    handlerDetails(data_row) {
        var user = AuthService.getCurrentUser();
        ApiService.getOrderDetails(user.token,data_row.original.Id).then(
            (res) => {
                if(res && res.status == 'success'){
                    const items = this.showImage(res.data.Purchases_detail).map(function(row) {
                        return { 
                          id: row.id, 
                          Imagen: row.imagen, 
                          Nombre : row.Product.name, 
                          Precio : row.price, 
                          Cantidad : row.quantity, 
                          Total : row.total,
                        }
                     })
                    
                     var type_address = data_row.original.data.type_address?data_row.original.data.type_address:'';
                     var address = data_row.original.data.address?data_row.original.data.address:'';
                     var number = data_row.original.data.number?data_row.original.data.number:'';
                     var start_time = res.data.hour_programmed_start?res.data.hour_programmed_start.toString():'';
                     var end_time = res.data.hour_programmed_end?res.data.hour_programmed_end.toString():'';

                    this.setState({ detailResults:items });
                    this.setState({ client: data_row.original.Usuario });
                    this.setState({ date: res.data.date_programmed?res.data.date_programmed:'' });
                    this.setState({ hour: start_time && end_time?start_time.slice(0, -3) + ' - ' + end_time.slice(0, -3):'' });
                    this.setState({ id_order: data_row.original.Id });
                    this.setState({ total_order: data_row.original.Total });
                    this.setState({ address: type_address+' '+address+' '+number });
                    this.setState({ cash: res.data.cash?parseInt(res.data.cash, 10):0 });
                    this.setState({ district: data_row.original.data.district?data_row.original.data.district:'' });
                    this.setState({ interior: data_row.original.data.interior?data_row.original.data.interior:'' });
                    this.setState({ url_google: data_row.original.data.url_google?data_row.original.data.url_google:'' });
                    this.setState({ delivery: res.data.delivery?res.data.delivery:"0.00" });
                    this.setState({ discount: res.data.discount?res.data.discount:"0.00" });
                    
                    this.renderDetailResults();
                    this.onOpenModal();
                }
            },
            error => {
              const resMessage =
                (error.response &&
                  error.response.data &&
                  error.response.data.message) ||
                error.message ||
                error.toString();
            }
          );
    }

    handlerAcept(data_row) {
        Swal.fire({
            title: 'Confirmar',
            text: '¿Desea aceptar la orden nro '+ data_row.original.Id + '?',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33', 
            confirmButtonText: 'Confirmar',
            cancelButtonText: 'Cancelar'
         }).then((result) => {
            if(result.value){
                
                var user = AuthService.getCurrentUser();
                let data = {
                    'idPurchase': data_row.original.Id,
                    'id_user': data_row.original.id_user,
                }
                ApiService.postAceptPurchase(user.token,data).then(
                    (res) => {
                        if(res && res.status == 'success'){
                            Swal.fire("Hecho!", "Orden Aceptada!", "success");
                            //toast.success("Orden Aceptada!");
                            this.setState({results: []});
                            this.getDataOrders();
                        }
                    },
                    error => {
                      const resMessage =
                        (error.response &&
                          error.response.data &&
                          error.response.data.message) ||
                        error.message ||
                        error.toString();
                    }
                  );




           }
         })
        //this.props.history.push("/edit-user/"+data_row.original.id);
        //window.location.reload();
    }

    handlerCancel(data_row) {
        Swal.fire({
            title: 'Confirmar',
            text: '¿Desea cancelar la orden nro '+ data_row.original.Id + '?',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33', 
            confirmButtonText: 'Confirmar',
            cancelButtonText: 'Cancelar'
         }).then((result) => {
            if(result.value){
                
                var user = AuthService.getCurrentUser();
                let data = {
                    'idPurchase': data_row.original.Id,
                    'id_user': data_row.original.id_user,
                }
                ApiService.postCancelPurchase(user.token,data).then(
                    (res) => {
                        if(res && res.status == 'success'){
                            Swal.fire("Hecho!", "Orden Cancelada!", "success");
                            this.setState({results: []});
                            this.getDataOrders();
                        }
                    },
                    error => {
                      const resMessage =
                        (error.response &&
                          error.response.data &&
                          error.response.data.message) ||
                        error.message ||
                        error.toString();
                    }
                  );




           }
         })
        //this.props.history.push("/edit-user/"+data_row.original.id);
        //window.location.reload();
    }

    handlerRemove(data_row) {
        Swal.fire({
            title: 'Confirmar',
            text: '¿Desea eliminar la orden nro '+ data_row.original.Id + '?',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33', 
            confirmButtonText: 'Confirmar',
            cancelButtonText: 'Cancelar'
         }).then((result) => {
            if(result.value){
                
                var user = AuthService.getCurrentUser();
                let data = {
                    'idPurchase': data_row.original.Id,
                    'id_user': data_row.original.id_user,
                }
                ApiService.postRemovePurchase(user.token,data).then(
                    (res) => {
                        if(res && res.status == 'success'){
                            Swal.fire("Hecho!", "Orden eliminada!", "success");
                            this.setState({results: []});
                            this.getDataOrders();
                        }
                    },
                    error => {
                      const resMessage =
                        (error.response &&
                          error.response.data &&
                          error.response.data.message) ||
                        error.message ||
                        error.toString();
                    }
                  );




           }
         })
        
    }

    onOpenModal = () => {
        this.setState({ open: true });
    };

    onCloseModal = () => {
        this.setState({ open: false });
    };

    componentWillReceiveProps(){
        //this.getDataOrders()
    }

    render() {
        const { open, results, sort, dateFrom, dateTo } = this.state;
        const sortedResults = sortRows(results, sort);

        const stats = [
            { label: 'Ticket promedio', value: fmtMoney(this.state.averageTicket), icon: 'fa-ticket', color: '#0d6efd' },
            { label: 'Total vendido', value: fmtMoney(this.state.dataSubCateg), icon: 'fa-money', color: '#27ae60' },
            { label: `Utilidad (${fmtPercent(this.state.profitUtility)})`, value: fmtMoney(this.state.dataUtility), icon: 'fa-line-chart', color: '#8e44ad' },
            { label: 'Envíos', value: fmtMoney(this.state.dataDelivery), icon: 'fa-truck', color: '#e67e22' },
            { label: 'Costos', value: fmtMoney(this.state.dataCosts), icon: 'fa-cubes', color: '#c0392b' },
            { label: 'Nro de órdenes', value: this.state.numTotalOrders, icon: 'fa-shopping-cart', color: '#0d6efd' },
            { label: 'Clientes activos', value: this.state.totalCustomers, icon: 'fa-users', color: '#27ae60' },
            { label: '% clientes activos', value: fmtPercent(this.state.percentageActiveCustomers), icon: 'fa-user-circle', color: '#8e44ad' },
            { label: 'Órdenes promedio / cliente', value: this.state.totalOrdersAverage, icon: 'fa-repeat', color: '#e67e22' },
            { label: 'Cash otorgado', value: fmtMoney(this.state.cashGranted), icon: 'fa-gift', color: '#20c997' },
            { label: 'Cash usado', value: fmtMoney(this.state.cashUsed), icon: 'fa-credit-card', color: '#d63384' },
        ];

        const periodLabel = dateFrom + '_a_' + dateTo;

        return (
            <Fragment>
                <Breadcrumb title="Reporte de Ventas" parent="Sales" />

                <div className="container-fluid">
                    <div className="row">
                        <div className="col-sm-12">
                            <div className="card" style={{ marginBottom: 16 }}>
                                <div className="card-body" style={{ padding: '12px 16px' }}>
                                    <div style={{ display: 'flex', flexWrap: 'wrap', alignItems: 'center', gap: 10 }}>
                                        <span style={{ fontSize: 13, fontWeight: 600, color: '#555', whiteSpace: 'nowrap' }}>
                                            Filtrar por fecha
                                        </span>
                                        <DateRangeInput
                                            from={this.state.dateFrom}
                                            to={this.state.dateTo}
                                            onApply={this.applyDateRange}
                                        />
                                    </div>
                                </div>
                            </div>

                            <StatCardsGrid stats={stats} columns={4} />

                            <div className="card" style={{ boxShadow: 'none', border: '1px solid #ebebeb' }}>
                                <div
                                    className="card-header"
                                    style={{
                                        display: 'flex', flexWrap: 'wrap', alignItems: 'center',
                                        justifyContent: 'space-between', gap: 10,
                                    }}
                                >
                                    <h5 style={{ margin: 0 }}>Pedidos del periodo</h5>
                                    <div style={{ display: 'flex', flexWrap: 'wrap', alignItems: 'center', gap: 10 }}>
                                        <input
                                            placeholder="Buscar..."
                                            name="filter"
                                            type="text"
                                            className="form-control"
                                            autoComplete="off"
                                            onInput={this.onChangeFilter}
                                            style={{
                                                flex: '1 1 180px', minWidth: 140, maxWidth: 260,
                                                height: 32, boxSizing: 'border-box', padding: '4px 10px',
                                            }}
                                        />
                                        {results.length > 0 && (
                                            <CSVLink
                                                className="btn btn-outline-primary btn-sm"
                                                data={sortedResults}
                                                headers={ORDER_HEADERS}
                                                filename={csvFilename(periodLabel)}
                                                style={{
                                                    display: 'inline-flex', alignItems: 'center', height: 32,
                                                    flexShrink: 0, whiteSpace: 'nowrap', boxSizing: 'border-box',
                                                }}
                                            >
                                                <i className="fa fa-file-excel-o" style={{ marginRight: 6 }} />
                                                Exportar
                                            </CSVLink>
                                        )}
                                    </div>
                                </div>
                                <div className="card-body" style={{ padding: 0 }}>
                                    {this.renderResults()}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <Modal open={open} onClose={this.onCloseModal} >

                <div className="modal-header">
                <h5 className="modal-title f-w-600" id="exampleModalLabel2">Orden n° {this.state.id_order}</h5>
                </div>
                <div className="modal-body">
                    <div style={{display: 'flex'}}>
                        <label style={{marginRight: '0.5rem',fontWeight: 'bold'}}>Usuario:</label>
                        {this.state.client}
                    </div>
                    
                    <div style={{display: 'flex'}}>
                        <label style={{marginRight: '0.5rem',fontWeight: 'bold'}}>Distrito:</label>
                        {this.state.district}
                    </div>
                    <div style={{display: 'flex'}}>
                        <label style={{marginRight: '0.5rem',fontWeight: 'bold'}}>Dirección:</label>
                        {this.state.address}
                    </div>
                    <div style={{display: 'flex'}}>
                        <label style={{marginRight: '0.5rem',fontWeight: 'bold'}}>Interior:</label>
                        {this.state.interior}
                    </div>
                    <div style={{display: 'flex'}}>
                        <label style={{marginRight: '0.5rem',fontWeight: 'bold'}}>Url Google:</label>
                        <a href={ this.state.url_google } target="blank">{this.state.url_google}</a>
                    </div>
                    <div style={{display: 'flex'}}>
                        <label style={{marginRight: '0.5rem',fontWeight: 'bold'}}>Fecha:</label>
                        {this.state.date}
                    </div>
                    <div style={{display: 'flex'}}>
                        <label style={{marginRight: '0.5rem',fontWeight: 'bold'}}>Hora:</label>
                        {this.state.hour}
                    </div>
                    {
                    this.state.cash>0?
                    <div style={{display: 'flex'}}>
                        <label style={{marginRight: '0.5rem',fontWeight: 'bold'}}>Crédito:</label>
                        {fmtMoney(this.state.cash)}
                    </div>
                    :''
                    }
                    <div style={{display: 'flex'}}>
                        <label style={{marginRight: '0.5rem',fontWeight: 'bold'}}>Delivery:</label>
                        {fmtMoney(this.state.delivery)}
                    </div>
                    <div style={{display: 'flex'}}>
                        <label style={{marginRight: '0.5rem',fontWeight: 'bold'}}>Total:</label>
                        {fmtMoney(this.state.total_order)}
                    </div>
                    <div style={{display: 'flex'}}>
                        <label style={{marginRight: '0.5rem',fontWeight: 'bold'}}>Descuento:</label>
                        {fmtMoney(this.state.discount)}
                    </div>
                    <div>
                    <label style={{fontWeight: 'bold'}}>Detalle:</label>
                    {this.renderDetailResults()}
                    </div>
                </div>
                <div className="modal-footer">
                </div>
                </Modal>
            </Fragment>
        )
    }
}

export default VerReportOrderList
